import { createSlice } from '@reduxjs/toolkit';

export interface UserStateData {
	token: string
	profile: {
		id: number;
		account: string;
		nickname: string;
		roles: string[];
		auth: string[];
	};
}

// Define initialization data
const initialState: UserStateData = {
	token: localStorage.getItem('token') || '',
	profile: {
		id: 0,
		nickname: '',
		account: '',
		auth: [],
		roles: [],
	},
};

const userStore = createSlice({
	name: 'User',
	initialState,
	reducers: {
		setUserProfile: (state, action) => {
			state.profile = action.payload
		},
		setToken: (state, action) => {
			state.token = action.payload
			localStorage.setItem('token', action.payload)
		},
		removeToken: (state) => {
			state.token = ''
			localStorage.removeItem('token')
		}
	},
});

export const { setUserProfile, setToken, removeToken } = userStore.actions;
export default userStore.reducer;
